// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__9Jcu5","pageButtons":"Pagination_pageButtons__24wAQ"};